<template>
  <v-badge
    :value="highlighted"
    color="error"
    icon="mdi-exclamation-thick"
    overlap
    bordered
  >
    <v-card
      v-if="visible"
      flat
      v-bind="$attrs"
      v-on="$listeners"
      class="mx-1 tab-btn clickable"
      :color="buttonColor">
      <v-card-text class="pa-2 d-flex flex-column align-center tab-content">
        <v-icon :small="small" class="mb-1" :color="iconColor">{{icon}}</v-icon>
        <span class="tab-text" :class="textColorClass">{{text}}</span>
      </v-card-text>
    </v-card>
  </v-badge>
</template>

<script>
export default {
  name: 'TabBtn',

  props: {
    visible: {
      type: Boolean,
      default: true
    },
    small: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      default: "mdi-car"
    },
    color: {
      type: String,
      default: 'primary',
    },
    highlighted: {
      type: Boolean,
      default: false
    },
  },

  computed: {
    buttonColor() {
      // If highlighted, invert: use the color as background
      // Otherwise use transparent for primary or the color itself
      if (this.highlighted) {
        return this.color
      }
      return this.color === 'primary' ? 'transparent' : this.color
    },
    iconColor() {
      // If highlighted, use on-primary/on-secondary color on colored background
      // Otherwise use the color for the icon
      if (this.highlighted) {
        if (this.color === 'primary') {
          return 'on-primary'
        } else if (this.color === 'secondary') {
          return 'on-secondary'
        }
        return 'white'
      }
      return this.color
    },
    textColorClass() {
      // If highlighted, use on-primary/on-secondary text on colored background
      // Otherwise use colored text
      if (this.highlighted) {
        if (this.color === 'primary') {
          return 'on-primary--text'
        } else if (this.color === 'secondary') {
          return 'on-secondary--text'
        }
        return 'white--text'
      }
      return this.color + '--text'
    }
  }
}
</script>

<style scoped>
.tab-btn {
  min-width: 60px !important;
  max-width: 80px !important;
  height: auto !important;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-btn:hover {
  opacity: 0.85;
}

.clickable {
  cursor: pointer;
}

.tab-content {
  width: 100% !important;
  max-width: 100% !important;
}

.tab-text {
  font-size: 11px !important;
  text-transform: none !important;
  line-height: 1.1 !important;
  word-break: normal !important;
  white-space: normal !important;
  text-align: center !important;
  width: 100% !important;
  display: block !important;
  overflow-wrap: break-word !important;
  font-weight: 500 !important;
}
</style>
